// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { cartTotalDisplayStyles } from "@flip/Overrides/Components/CartTotalDisplay";
import { fontConfig } from "@flip/XDL/PreStyle/typography";
import { color, mergeWithCss, xScreen } from "@flip/XDL/Utilities";
import { TypographyProps } from "@insite/mobius/Typography";
import { css } from "styled-components";

const floatOnPrint = css`
    &&&& {
        @media print {
            float: right;
        }
    }
`;

const sharedLabelTextStyles: TypographyProps = {
    as: "p",
    size: 14,
    lineHeight: "22px",
    weight: fontConfig.weight.regular,
    css: css`
        margin-bottom: 0;
    `,
};

const sharedValueTextStyles: TypographyProps = {
    ...mergeWithCss(sharedLabelTextStyles, {
        css: css`
            margin-left: auto;
            ${floatOnPrint}
        `,
    }),
    weight: fontConfig.weight.semiBold,
};

cartTotalDisplayStyles.container = {
    gap: 0,
    offsetCss: css`
        row-gap: 8px;
    `,
};

cartTotalDisplayStyles.labelGridItem = cartTotalDisplayStyles.valueGridItem = {
    width: 6,
};

cartTotalDisplayStyles.subtotalLabel =
    cartTotalDisplayStyles.shippingAndHandlingLabel =
    cartTotalDisplayStyles.taxLabel =
        {
            ...sharedLabelTextStyles,
        };

cartTotalDisplayStyles.promotionValue =
    cartTotalDisplayStyles.subtotalValue =
    cartTotalDisplayStyles.discountsValue =
    cartTotalDisplayStyles.shippingAndHandlingValue =
    cartTotalDisplayStyles.otherChargesValue =
    cartTotalDisplayStyles.taxValue =
        {
            ...sharedValueTextStyles,
        };

cartTotalDisplayStyles.totalLabel = {
    size: 16,
    lineHeight: "26px",
    weight: fontConfig.weight.regular,
    as: "p",
    css: css`
        margin-bottom: 0;
    `,
};

cartTotalDisplayStyles.totalValue = {
    size: 16,
    lineHeight: "26px",
    weight: fontConfig.weight.semiBold,
    as: "p",
    css: css`
        margin-bottom: 0;
        margin-left: auto;
        ${floatOnPrint}
    `,
};

cartTotalDisplayStyles.loadingSpinner = {
    size: 15,
    css: css`
        margin-top: auto;
        margin-bottom: auto;
        margin-left: auto;
    `,
};

cartTotalDisplayStyles.titleGridItem = {
    width: 12,
};

cartTotalDisplayStyles.titleText = {
    variant: "h5",
    as: "p",
    css: css`
        margin-bottom: 0;
    `,
};

cartTotalDisplayStyles.dividerGridItem = {
    width: 12,
    css: css`
        border-top: 1px solid ${color("common.border")};
        &&& {
            margin: 7px 0;
        }
    `,
};

cartTotalDisplayStyles.shippingDisclaimerContainer = {
    width: 12,
    css: css`
        padding: 8px;
        background: ${color("common.ui15")};
    `,
};

cartTotalDisplayStyles.shippingDisclaimer = {
    ...sharedValueTextStyles,
};

cartTotalDisplayStyles.emptyGridItem = {
    width: 12,
    css: css`
        &&& {
            margin: 15px 0 0;
        }
    `,
};

cartTotalDisplayStyles.notify = {
    css: css`
        min-width: unset;
    `,
};

cartTotalDisplayStyles.minOrderRquirmentGridItem = {
    width: 12,
    css: css`
        justify-content: space-between;
    `,
};

cartTotalDisplayStyles.minOrderRquirmentMsg = {
    forwardAs: "p",
    color: "danger",
    size: 14,
    lineHeight: "22px",
};

cartTotalDisplayStyles.feelabel = {
    variant: "legend",
    weight: "bold",
    lineHeight: "22px",
    css: css`
        display: block;
        margin-bottom: 0;
        ${xScreen("lte", "md")} {
            line-height: 14px;
            padding: 4px 0;
        }
        ${xScreen("lte", "xs")} {
            line-height: 22px;
            padding: 0;
        }
    `,
};

cartTotalDisplayStyles.feeMessage = {
    variant: "legend",
    css: css`
        display: block;
        margin-bottom: 0;
    `,
};

cartTotalDisplayStyles.feeLabelGridItem = {
    width: [7, 7, 7, 9, 9],
    css: css`
        display: flex;
        flex-direction: column;
    `,
};

cartTotalDisplayStyles.feeValueGridItem = {
    width: [5, 5, 5, 3, 3],
};
